import 'babel-polyfill'
import Es6Promise from 'es6-promise'
// eslint-disable-next-line
require('es6-promise').polyfill()
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import { axiosPostHttp,axiosGetHttp,getQueryString } from './utils/request.js';

Vue.prototype.$axiosGetHttp = axiosGetHttp;
Vue.prototype.$axiosPostHttp = axiosPostHttp;
Vue.prototype.$getQueryString = getQueryString;

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'YOUR_APP_KEY',
})
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app')
